// extracted by mini-css-extract-plugin
export default {"ctaContainer":"FAQRedirect_ctaContainer__RZDlG","textContent":"FAQRedirect_textContent__+Ieus","ctaButton":"FAQRedirect_ctaButton__TqKPS"};